export const GLOBAL_ISSUE_CATEGORIES_RESET_STATE = 'GLOBAL_ISSUE_CATEGORIES_RESET_STATE';
export const GLOBAL_ISSUE_CATEGORIES_CURRENT_ITEM = 'GLOBAL_ISSUE_CATEGORIES_CURRENT_ITEM';

export const GLOBAL_ISSUE_CATEGORIES_REQUEST_LOADING = 'GLOBAL_ISSUE_CATEGORIES_REQUEST_LOADING';
export const GLOBAL_ISSUE_CATEGORIES_REQUEST_SUCCESS = 'GLOBAL_ISSUE_CATEGORIES_REQUEST_SUCCESS';
export const GLOBAL_ISSUE_CATEGORIES_REQUEST_FAILED = 'GLOBAL_ISSUE_CATEGORIES_REQUEST_FAILED';

export const GLOBAL_ISSUE_CATEGORIES_CURRENT_ACTION = 'GLOBAL_ISSUE_CATEGORIES_CURRENT_ACTION';
export const GLOBAL_ISSUE_CATEGORIES_RESET_ACTION = 'GLOBAL_ISSUE_CATEGORIES_RESET_ACTION';